import * as React from "react";
import { CursorMetaData } from "../../../interfaces/ApiResponse";
import GuardianMessageInterface from "../../../interfaces/GuardianMessageInterface";
import StudentInterface from "../../../interfaces/StudentInterface";
import SplitLayout from "../../atoms/SplitLayout";
import GuardianMessageForm from "./GuardianMessageForm";
import GuardianMessageHeader from "./GuardianMessageHeader";
import GuardianMessageList from "./GuardianMessageList";
import styles from "./styles.scss";

export type GuardianMessageProps = {
  data: GuardianMessageInterface[];
  meta: CursorMetaData;
  loading: boolean;
  hasMore: boolean;
};
interface Props {
  student: StudentInterface;
  guardianMessagesProps: GuardianMessageProps;
  onCloseRightColumn?: (e: any) => void;
  showCloseIcon?: boolean;
  loadMoreMessages: () => void;
  updateCurrentThreadLatestMessage?: (
    guardianMessage: GuardianMessageInterface,
  ) => void;
}

const GuardianMessage = (props: Props) => {
  const [postedGuardianMessages, setPostedGuardianMessages] = React.useState<
    GuardianMessageInterface[]
  >([]);
  const splitLayoutRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => setPostedGuardianMessages([]), [props.student.id]);

  if (!props.student) {
    return null;
  }

  const unshiftGuardianMessage = (messages: GuardianMessageInterface[]) => {
    setPostedGuardianMessages([...messages, ...postedGuardianMessages]);
  };

  const showCloseIcon =
    typeof props.showCloseIcon === "undefined" ? true : props.showCloseIcon;

  return (
    <div className={styles.root} ref={splitLayoutRef}>
      <SplitLayout.Header>
        <GuardianMessageHeader
          student={props.student}
          onClose={props.onCloseRightColumn}
          showCloseIcon={showCloseIcon}
        />
      </SplitLayout.Header>
      <SplitLayout.Body>
        {props.guardianMessagesProps.data || postedGuardianMessages ? (
          <GuardianMessageList
            student={props.student}
            guardianMessageProps={props.guardianMessagesProps}
            postedGuardianMessages={postedGuardianMessages}
            loadMoreMessages={props.loadMoreMessages}
          />
        ) : null}
        <GuardianMessageForm
          student={props.student}
          unshiftGuardianMessage={unshiftGuardianMessage}
          updateCurrentThreadLatestMessage={
            props.updateCurrentThreadLatestMessage || undefined
          }
          textareaMaxHeightBaseElementRef={splitLayoutRef}
        />
      </SplitLayout.Body>
    </div>
  );
};

export default GuardianMessage;
